// extracted by mini-css-extract-plugin
export var fullWidthButton = "_er-0";